import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { Button, Modal, ModalBody, ModalHead, ModalFoot } from 'mailup-web-components'
import { modalErrorState } from 'Pages/MessageEdit/recoil/state/modals'

const ModalError = () => {
  const intl = useIntl()
  const { show, customErrorTitle, customErrorDesc } = useRecoilValue(modalErrorState)
  const resetModal = useResetRecoilState(modalErrorState)

  const handleClose = () => {
    resetModal()
  }

  return (
    <Modal
      show={show}
      showClose
      closeOnOverlayClick={false}
      onClose={handleClose}
      data-mu-test='modal-message-edit-error'
    >
      <ModalHead title={customErrorTitle} />
      <ModalBody>
        {customErrorDesc ? (
          <p>{customErrorDesc}</p>
        ) : (
          <p>
            {intl.formatMessage({
              id: 'Load.Bee.SavingMessageError'
            })}
          </p>
        )}
      </ModalBody>

      <ModalFoot>
        <Button onClick={handleClose} kind='primary'>
          {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalError
